<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.student_name"
        placeholder="请输入学生姓名"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-date-picker
        v-model="listQuery.school_year"
        type="year"
        class="filter-item"
        value-format="yyyy"
        placeholder="选择学年"
      >
      </el-date-picker>
      <el-input
        v-model="listQuery.grade_name"
        placeholder="请输入年级"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.major_name"
        placeholder="请输入专业"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.class_name"
        placeholder="请输入班级"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-button class="filter-item" type="primary" @click="handleFilter"
        >搜索</el-button
      >
    </div>
    <div class="filter-container">
      <span>学校:{{ data.school.name }}</span>
      <span style="margin-left: 15px">教室:{{ data.name }}</span>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column label="ID" width="95" align="center">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="学生姓名" min-width="110" align="center">
        <template slot-scope="scope"> {{ scope.row.class_student.student.name }}</template>
      </el-table-column>
      <el-table-column label="电话" min-width="110" align="center">
        <template slot-scope="scope"> {{ scope.row.class_student.student.phone }}</template>
      </el-table-column>
      <!-- <el-table-column label="性别" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.classes.college.name }}
        </template>
      </el-table-column> -->
      <el-table-column label="学年" min-width="110" align="center">
        <template slot-scope="scope">
          {{
            scope.row.class_student.classes ? scope.row.class_student.classes.school_year : ""
          }}
          ~
          {{
            scope.row.class_student.classes
              ? scope.row.class_student.classes.school_year - 0 + 1
              : ""
          }}
        </template>
      </el-table-column>
      <el-table-column label="年级" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.class_student.classes.grade.name }}
        </template>
      </el-table-column>
      <el-table-column label="专业" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.class_student.classes.major.name }}
        </template>
      </el-table-column>
      <el-table-column label="班级" min-width="110" align="center">
        <template slot-scope="scope"> {{ scope.row.class_student.classes.name }}</template>
      </el-table-column>
      <el-table-column label="第几次扫码上机" min-width="110" align="center">
        <template slot-scope="scope"> {{ scope.row.study_index }}</template>
      </el-table-column>
      <el-table-column label="上机时间/下机时间" min-width="220" align="center">
        <template slot-scope="scope"> {{ scope.row.start_at }}&nbsp;&nbsp;/&nbsp;&nbsp;{{ scope.row.end_at }}</template>
      </el-table-column>
      <el-table-column label="上机时长" min-width="110" align="center">
        <template slot-scope="scope"> {{ scope.row.duration }}秒</template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      list: [],
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        id: "",
        school_id: "",
        classroom_id: "",
        student_name: "",
        school_year: "",
        grade_name: "",
        major_name: "",
        class_name: "",
      },
      textMap: { update: "修改", create: "新增" },
      dialogFormVisible: false,
      dialogStatus: "",
      btnLoading: false,
      form: {
        id: "",
        class_id: "",
        student_id: "",
      },
      yulanData: [],
    };
  },
  created() {
    // this.form.class_id = this.$route.query.id;
    this.data = JSON.parse(this.$route.query.data);
    this.listQuery.classroom_id = this.data.id;
    console.log(this.data);
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/classroom/classLog",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    resetForm() {
      this.form = {
        id: "",
        class_id: this.form.class_id,
        class_student_internship_log: {
          sex: "",
          contact_phone: "",
          now_internship_company: "",
          urgent_contact: "",
          urgent_contact_phone: "",
        },
      };
    },
    handleCreate() {
      this.resetForm();
      this.dialogStatus = "create";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    handleUpdate(row) {
      this.resetForm();
      this.form = Object.assign({}, row);
      if (!this.form.class_student_internship_log) {
        this.form.class_student_internship_log = {
          sex: "",
          contact_phone: "",
          now_internship_company: "",
          urgent_contact: "",
          urgent_contact_phone: "",
        };
      }
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    saveData() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/school/classStudentInternshipStore",
            method: "post",
            data: {
              class_student_id: this.form.id,
              sex: this.form.class_student_internship_log.sex,
              student_no: this.form.student.account,
              now_internship_company:
                this.form.class_student_internship_log.now_internship_company,
              contact_phone:
                this.form.class_student_internship_log.contact_phone,
              urgent_contact:
                this.form.class_student_internship_log.urgent_contact,
              urgent_contact_phone:
                this.form.class_student_internship_log.urgent_contact_phone,
            },
          })
            .then((response) => {
              this.btnLoading = false;
              this.dialogFormVisible = false;
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.getList();
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.filter-container {
  display: flex;
}
</style>
